import { render, staticRenderFns } from "./ArticleCreateUpdate.vue?vue&type=template&id=b2509e8a&"
import script from "./ArticleCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./ArticleCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports